export const POSTHOG_API_KEY =
  "phc_VsHW5HxTzpORanESQh9A08tmZLQkKbtIBTYoQvRpPOp";
export const TELEMETRY_DISABLED_ENV_VAR = "BASE44_DISABLE_TELEMETRY";
export const POSTHOG_REQUEST_TIMEOUT_MS = 1000;
